<template><!--帮助说明-->
  <div style="padding: 20px">

    <el-row :gutter="20" style="margin-bottom: 30px">
      <el-col :span="8">
        <div class="grid-content bg-purple-1" @click="goToRouter('AboutAccount')">
          <i class="el-icon-user-solid grid-content-i"></i>
          <div>关于账户</div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content bg-purple-2" @click="goToRouter('ChatRelated')">
          <i class="el-icon-chat-dot-round grid-content-i"></i>
          <div>聊天相关</div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content bg-purple-3" @click="goToRouter('RulesPlatform')">
          <i class="el-icon-s-home grid-content-i"></i>
          <div>平台规则</div>
        </div>
      </el-col>
      <!--<el-col :span="6"><div class="grid-content bg-purple-4"></div></el-col>-->
    </el-row>

    <div>常见问题</div>
    <hr>
    <el-collapse v-model="activeName" accordion>
      <el-collapse-item title="禁止第三平台" name="1">
        <div class="collapse-item-div">● 询问个人信息添加微信qq或其他第三方平台的行为多为诈骗行为，平台禁止发送或诱导其他用户发送第三方联系方式。</div>
      </el-collapse-item>
      <el-collapse-item title="哪些情况会被封禁" name="2">
        <div class="collapse-item-div">● 发送或诱导其他用户发送第三方平台账号。</div>
        <div class="collapse-item-div">● 发送广告、色情暴力、政治敏感、诈骗相关内容。</div>
        <div class="collapse-item-div">● 使用脚本、批量复制粘贴、随机文字聊天等非正常聊天行为。</div>
        <div class="collapse-item-div">● 以辱骂、低俗等为由被举报多次并被核实的用户。</div>
        <div class="collapse-item-div">● 其他破坏平台环境的行为。</div>
      </el-collapse-item>
      <el-collapse-item title="用户个人页异常" name="3">
        <div class="collapse-item-div">● 用户个人页提示异常，表明改用户由于违反平台规则处于被封禁期。</div>
        <div class="collapse-item-div">● 用户个人页提示该用户消失了，表明该用户已注销账号。</div>
      </el-collapse-item>
    </el-collapse>

  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: '1',
      sex: this.$route.query.sex,//  性别: 1男 2女
    }
  },
  methods: {
    //  跳转路由
    goToRouter(address) {
      let path = '/helptext/' + address;
      console.log(path)
      this.$router.push({path: path, query: {sex: this.sex}});
    },
  },
  created() {
  }
}
</script>
<style>

.grid-content {
  height: 90px;
  border-radius: 10px;
  text-align: center;
  font-size: 12px;
  color: #ffffff;
}

.grid-content-i {
  padding-top: 10px;
  margin-bottom: 10px;
  font-size: 40px;
}

.bg-purple-1 {
  background: #5d2cdc;
}

.bg-purple-2 {
  background: #26c98a;
}

.bg-purple-3 {
  background: #fc9825;
}

.bg-purple-4 {
  background: #e5e9f2;
}

.collapse-item-div {
  margin-left: 15px;
}

</style>
